module.exports = __webpack_public_path__ + "static/media/fly0083.33cf6c0b.webp";